import React, { useCallback, useMemo } from "react";
import { Container } from "Components/ReactstrapSlim";
import useMediaBreakpointDown from "Hooks/useMediaBreakpointDown";
import { PricingFeaturesList, PricingCard, PricingMobileCard } from "../../../../../components";
import { useContextUsModal } from "../../../../../hooks";

import classes from "./PricingSectionPlansBlock.module.scss";

import PLANS from "../../../../../data/PLANS";
import { OfficeBuilding, User } from "Components/Icons";

const ICONS = {
   "individual": <User />,
   "enterprise": <OfficeBuilding />,
}

const PricingSectionPlansBlock: React.FC = () => {
   const isMobile = useMediaBreakpointDown("sm");
   const { open } = useContextUsModal()

   const goToFindSpace = useCallback(() => {
      window.location.href = "/search";
   }, []);

   const getSolutionLink = useCallback((id: string) => `/solutions/${id}`, []);

   const plans = useMemo(
      () =>
         PLANS.map((p) => ({
            action: p.id === "individual" ? goToFindSpace : () => open(p.id),
            icon: ICONS[p.id] ?? null,
            ...p,
         })),
      [open, goToFindSpace]
   );

   return (
      <div className={classes.container}>
         <Container className={classes.cardGrid}>
            {plans.map((item) =>
               isMobile ? (
                  <PricingMobileCard
                     key={item.id}
                     title={item.name}
                     price={item.price}
                     description={item.description}
                     action={item.action}
                     actionText={item.actionName}
                     icon={item.icon}
                     link={getSolutionLink(item.id)}
                  >
                     <PricingFeaturesList features={item.features} />
                  </PricingMobileCard>
               ) : (
                     <PricingCard
                        key={item.id}
                        title={item.name}
                        price={item.price}
                        priceText={item.priceText}
                        description={item.description}
                        action={item.action}
                        actionText={item.actionName}
                        icon={item.icon}
                        link={getSolutionLink(item.id)}
                     >
                        <PricingFeaturesList features={item.features} />
                     </PricingCard>
               )
            )}
         </Container>
      </div>
   );
};

export default PricingSectionPlansBlock;
